import './styles/graphic.scss';
import json from './data/data.json';


const params = new URLSearchParams(location.search);
const area = params.get('area');

const data = json;

export default function (props, container) {
  // Create one modal at container level to overlay entire graphic
  const modal = container.append('div')
    .attr('class', 'modal')
    .style('display', 'none');

  const modalContent = modal.append('div')
    .attr('class', 'modal-content');

  const closeBtn = modalContent.append('span')
    .attr('class', 'modal-close')
    .html('&times;')
    .on('click', () => {
      modal.style('display', 'none');
    });

  // Create header container for image and basic info
  const modalHeader = modalContent.append('div')
    .attr('class', 'modal-header');

  const modalImage = modalHeader.append('img')
    .attr('class', 'modal-image');

  const modalInfo = modalHeader.append('div')
    .attr('class', 'modal-info');

  const modalName = modalInfo.append('h3')
    .attr('class', 'modal-name');

  const modalAge = modalInfo.append('p')
    .attr('class', 'modal-age');

  const modalStatus = modalInfo.append('p')
    .attr('class', 'modal-status');

  // Bio container goes outside the header
  const modalNote = modalContent.append('div')
    .attr('class', 'modal-bio-container');

  // Add navigation controls
  const modalNav = modalContent.append('div')
    .attr('class', 'modal-nav');

  const prevBtn = modalNav.append('button')
    .attr('class', 'modal-nav-btn modal-nav-btn-prev')
    .html('<svg class="arrow-left" width="20" height="18" aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" fill="currentColor" viewBox="0 0 20 18"><path d="M19.7967 9.06344L11.9428 16.9388C11.6717 17.2105 11.2324 17.2105 10.961 16.9388C10.69 16.667 10.69 16.2263 10.961 15.9545L17.5835 9.25701H0.68964C0.161428 9.25701 0 8.91844 0 8.60202C0 8.24595 0.283927 7.88559 0.68964 7.88559H17.5863L10.961 1.18812C10.69 0.916335 10.69 0.475623 10.961 0.203838C11.2324 -0.0679461 11.6717 -0.0679461 11.9428 0.203838L19.7967 8.07916C20.0678 8.35095 20.0678 8.79166 19.7967 9.06344Z"></path></svg>');

  const navCounter = modalNav.append('span')
    .attr('class', 'modal-nav-counter')
    .style('color', '#666')
    .style('font-size', '14px');

  const nextBtn = modalNav.append('button')
    .attr('class', 'modal-nav-btn modal-nav-btn-next')
    .html('<svg class="arrow-right" width="20" height="18" aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" fill="currentColor" viewBox="0 0 20 18"><path d="M19.7967 9.06344L11.9428 16.9388C11.6717 17.2105 11.2324 17.2105 10.961 16.9388C10.69 16.667 10.69 16.2263 10.961 15.9545L17.5835 9.25701H0.68964C0.161428 9.25701 0 8.91844 0 8.60202C0 8.24595 0.283927 7.88559 0.68964 7.88559H17.5863L10.961 1.18812C10.69 0.916335 10.69 0.475623 10.961 0.203838C11.2324 -0.0679461 11.6717 -0.0679461 11.9428 0.203838L19.7967 8.07916C20.0678 8.35095 20.0678 8.79166 19.7967 9.06344Z"></path></svg>');

  // Track current person and all people
  let currentPersonIndex = 0;
  let allPeople = [];

  // Function to update modal content
  function updateModalContent(person, index) {
    currentPersonIndex = index;

    modalImage.attr('src', person.image).attr('alt', person.name).attr('class', `modal-image ${person.grouping}`);
    modalName.text(person.name).attr('class', `modal-name ${person.grouping}`);

    modalAge.html(typeof (person.age) === 'number' ? `Age ${person.age}` : person.age);
    modalStatus.text(`${groupTitles[person.grouping]}`);

    // Clear previous bio content and split by line breaks
    modalNote.html('');
    const bioLines = person.bio ? person.bio.split('\n').filter(line => line.trim()) : [];
    bioLines.forEach((line) => {
      modalNote.append('p')
        .attr('class', line === 'Biography not available' ? 'modal-bio note' : 'modal-bio')
        .text(line);
    });

    // Update counter
    navCounter.text(`${index + 1} of ${allPeople.length}`);

    // Update button states
    prevBtn.attr('disabled', index === 0 ? true : null);
    nextBtn.attr('disabled', index === allPeople.length - 1 ? true : null);
  }

  // Use native event listeners for proper event.stopPropagation support
  prevBtn.node().addEventListener('click', (e) => {
    e.stopPropagation();
    if (currentPersonIndex > 0) {
      updateModalContent(allPeople[currentPersonIndex - 1], currentPersonIndex - 1);
    }
  });

  nextBtn.node().addEventListener('click', (e) => {
    e.stopPropagation();
    if (currentPersonIndex < allPeople.length - 1) {
      updateModalContent(allPeople[currentPersonIndex + 1], currentPersonIndex + 1);
    }
  });

  // Prevent modal content from closing when clicked
  modalContent.node().addEventListener('click', (e) => {
    e.stopPropagation();
  });

  // Close modal when clicking on backdrop
  modal.node().addEventListener('click', () => {
    modal.style('display', 'none');
  });

  // Group data by grouping attribute
  const groupedData = data.reduce((acc, item) => {
    const group = item.grouping;
    if (!acc[group]) {
      acc[group] = [];
    }
    acc[group].push(item);
    return acc;
  }, {});

  // Define group order and display names
  const groupOrder = ['presumed-alive', 'status-unknown', 'presumed-dead'];
  const groupTitles = {
    'presumed-alive': 'Presumed alive',
    'status-unknown': 'Status unknown',
    'presumed-dead': 'Presumed dead',
  };

  // Build allPeople array in order
  groupOrder.forEach((groupKey) => {
    if (groupedData[groupKey]) {
      allPeople = allPeople.concat(groupedData[groupKey]);
    }
  });

  // Create sections for each group
  groupOrder.forEach((groupKey) => {
    if (groupedData[groupKey]) {
      // Create group section
      const groupSection = container.append('div')
        .attr('class', `group-section ${groupKey}`);

      // Add group title with count
      const groupTitleElement = groupSection.append('h2')
        .attr('class', 'group-title');

      groupTitleElement.append('span')
        .text(groupTitles[groupKey]);

      groupTitleElement.append('span')
        .attr('class', 'group-count')
        .text(` ${groupedData[groupKey].length}`);

      // Create container for profiles in this group
      const profilesContainer = groupSection.append('div')
        .attr('class', 'profiles-container');

      // Add profiles for this group
      groupedData[groupKey].forEach((person) => {
        const prof = profilesContainer.append('div')
          .attr('class', 'profile')
          .style('cursor', 'pointer')
          .on('click', () => {
            // Find the index of this person in allPeople array
            const personIndex = allPeople.findIndex(p => p === person);

            // Update modal content
            updateModalContent(person, personIndex);

            // Position modal content over the group section
            const groupRect = groupSection.node().getBoundingClientRect();
            const modalContentNode = modalContent.node();
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

            // Center the modal on the group section
            modalContentNode.style.position = 'absolute';
            modalContentNode.style.top = `${groupRect.top + scrollTop + groupRect.height / 2}px`;
            modalContentNode.style.left = `${groupRect.left + groupRect.width / 2}px`;
            modalContentNode.style.transform = 'translate(-50%, -50%)';

            // Show modal
            modal.style('display', 'block');
          });

        const image = prof.append('div')
          .attr('class', 'image-container')
          .attr('id', person.name.replace(/\s+/g, '-').toLowerCase());

        image.append('img')
          .attr('src', `${person.image}`)
          .attr('alt', person.name);

        const labels = prof.append('div')
          .attr('class', 'titles');

        labels.append('span')
          .attr('class', 'name')
          .text(`${person.name}`);

        labels.append('span')
          .attr('class', 'age')
          .html(person.age);
      });
    }
  });
}
